import React from 'react';

import { Responsive } from 'app/shared/components/atoms';
import { Box } from 'app/shared/components/atoms';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { EventPageTemplate } from 'app/fan/components/templates';

import { EnterCompetitionButton } from './EnterCompetitionButton';

interface CompetitionFlowPreWinProps {
  'data-qaid'?: string;
}

export const CompetitionFlowPreWinContainer: React.FC<
  React.PropsWithChildren<CompetitionFlowPreWinProps>
> = ({ 'data-qaid': qaId = 'event-page-competition-flow-pre-win' }) => {
  const { event, eventAttendee, isPlusOneFlow } = useEventPageContext();

  if (!event || !event.competition) {
    return null;
  }

  return (
    <EventPageTemplate
      data-qaid={qaId}
      event={event}
      ticketSaleStatus="available"
      attendeeState={isPlusOneFlow ? undefined : eventAttendee?.currentState}
      secondColumn={
        <Box p={[4, 6, 4, 6]}>
          <EnterCompetitionButton />
        </Box>
      }
    >
      <Box data-qaid="event-page-first-column-children">
        <Responsive hideUp="smallDesktop">
          <Box p={[4, 6, 4, 6]}>
            <EnterCompetitionButton />
          </Box>
        </Responsive>
      </Box>
    </EventPageTemplate>
  );
};

export const CompetitionFlowPreWinEventPage: React.FC<
  React.PropsWithChildren<CompetitionFlowPreWinProps>
> = ({ 'data-qaid': qaId }) => {
  const { event } = useEventPageContext();

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect this to be present
  if (!event) {
    return null;
  }

  return <CompetitionFlowPreWinContainer data-qaid={qaId} />;
};
